import {
  ASSIGNMENT_MODAL_BUTTON_ABLE,
  ASSIGNMENT_MODAL_BUTTON_DISABLE,
  ASSIGNMENT_MODAL_CLOSE,
  ASSIGNMENT_MODAL_OPEN,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN
} from "../action-types/utils-types";

export const openAssignmentModalRestaurantsProducts = () => {
  return {
    type: ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN,
  };
};
export const closeAssignmentModalRestaurantsProducts = () => {
  return {
    type: ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE,
  };
};
export const openAssignmentModal = () => {
  return {
    type: ASSIGNMENT_MODAL_OPEN,
  };
};
export const closeAssignmentModal = () => {
  return {
    type: ASSIGNMENT_MODAL_CLOSE,
  };
};
export const disableAssignmentButton = () => {
  return {
    type: ASSIGNMENT_MODAL_BUTTON_DISABLE,
  };
};
export const ableAssignmentButton = () => {
  return {
    type: ASSIGNMENT_MODAL_BUTTON_ABLE,
  };
};
